import request from '@/utils/requestVr'
// 查询存储过期列表分页
export function fetchList(query) {
    return request({
        url: '/vr/storage/expire/stat/renew/page',
        method: 'get',
        params: query,
    })
}
// 查询存储过期列不分页表分页
export function fetchListPage(query) {
    return request({
        url: '/vr/storage/expire/stat/renew/list',
        method: 'get',
        params: query,
    })
}
// 查询存储过期详细
export function getObj(id) {
    return request({
        url: '/vr/storage/expire/stat/renew/detail?id=' + id,
        method: 'get',
    })
}
// 新增存储过期
export function addObj(data) {
    return request({
        url: '/vr/storage/expire/stat/renew/add',
        method: 'post',
        data: data,
    })
}
// 禁用启用存储过期
export function editStatus(data) {
    return request({
        url: '/vr/storage/package/status',
        method: 'post',
        data: data,
    })
}
// 修改存储过期
export function putObj(data) {
    return request({
        url: '/vr/storage/expire/stat/renew/edit',
        method: 'post',
        data: data,
    })
}
// 删除存储过期
export function delObj(data) {
    return request({
        url: '/vr/storage/expire/stat/renew/delete',
        method: 'post',
        data: data,
    })
}

// 获取过期统计详情
export function getDetail(params) {
  return request({
    url: '/vr/storage/expire/stat/renew/detail',
    method: 'GET',
    params,
  })
}
